'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import { GRACE_PERIOD_MS } from '../../config/exitIntent';
import { hasWarmedUp, markWarmedUp } from '../../model/exit-intent/session';
import { ExitIntentModal } from './ExitIntentModal';
export function ExitIntentHost(t0) {
  const $ = _c(4);
  const {
    branchId
  } = t0;
  const [isWarm, setIsWarm] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (hasWarmedUp()) {
        setIsWarm(true);
        return;
      }
      markWarmedUp();
      const timeoutId = setTimeout(() => setIsWarm(true), GRACE_PERIOD_MS);
      return () => clearTimeout(timeoutId);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!isWarm) {
    return null;
  }
  let t3;
  if ($[2] !== branchId) {
    t3 = <ExitIntentModal branchId={branchId} />;
    $[2] = branchId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}